export default __webpack_public_path__ + "static/media/SI.d9bee7b5.svg";